import { BaseService } from './base-service';

class PermissionService extends BaseService {
  /********************************
   * 业务规则
   ********************************/
  /**
   *  业务规则-业务规则列表
   *
   * @returns
   * @memberof BusinessRules
   */
  getRuleListByEntity(params) {
    return this.request({
      method: 'GET',
      url: '/entity/field/permission/manager/list',
      params
    });
  }
  /**
   *  业务规则-业务规则-动作列表
   *
   * @returns
   * @memberof BusinessRules
   */
  getActionListByEntity(params) {
    return this.request({
      method: 'GET',
      url: '/entity/setting/permission/action/list',
      params
    });
  }
  /**
   * 翻译条件，本地保存后列表回显使用
   *
   * @returns
   * @memberof BusinessRules
   */
  translateCondition(data) {
    return this.request({
      method: 'POST',
      url: `/entity/field/permission/condition/translate`,
      data
    });
  }
}

export const permissionService = new PermissionService();
